import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const ProductEnquiry = ({ listing_id,seller_id }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    const { name, email, phone, message } = formData;
  
    if (!name || !email || !phone || !message) {
      return Swal.fire("Please fill in all fields.", "", "warning");
    }
  
    const enquiryData = {
      ...formData,
      listing_id,
      seller_id,
    };
  
    console.log("Sending enquiry data:", enquiryData); // 👈 Log the data here
  
    try {
      await axios.post(`${baseurl}submitEnquiry`, enquiryData);
  
      Swal.fire("Enquiry Submitted!", "We'll contact you shortly.", "success").then(() => {
        window.location.reload(); // 🔁 Reload the page after alert confirmation
      });
  
      setFormData({ name: "", email: "", phone: "", message: "" });
  
      // Close the modal using Bootstrap's method
      document.querySelector(".btn-close").click();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to submit enquiry. Try again later.", "error");
    }
  };
  
  
  return (
    <div className=" text-start">
      <span
        type="button"
        class=" adcas"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        Enquire Now
      </span>

      <div
        class="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Product Enquiry
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="mb-2">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <input
                  type="text"
                  name="phone"
                  className="form-control"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <textarea
                  name="message"
                  className="form-control"
                  placeholder="Message"
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary"
                onClick={handleSubmit}
              >
                Submit Enquiry
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductEnquiry;
